<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('orders')">Orders</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ data.organization.name }}
    </h1>
    <trashed-message v-if="order.deleted_at && $page.props.auth.user.owner" class="mb-6" @restore="restore">
      This order has been deleted.
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-8xl " id="order-detail">
     
        <div class="p-8 -mr-6 -mb-8 max-w-3xl" style="width:90%;margin:auto;">
            <span style="padding:8px;" > 
                    <pdf  :src="data.label.file_path" style="width: 75%;"></pdf>
                <!-- <p style="margin-top:20px;"> 
                    {{data.label.label_name}} -- 
                    <a :href="data.label.file_path" target="_blank" >
                        View Full
                    </a>
                </p> -->
            </span>          
        </div>

        <div class="p-8 -mr-6 -mb-8 max-w-3xl" style="margin-bottom:4rem;display:block;width:90%;">
            <span style="padding:8px;" >
                <span>
                    <h1 class="mb-4 font-bold text-1xl"> Customer : {{data.organization.name}}</h1>
                </span>
                <span>
                    <h1 class="mb-4 font-bold text-1xl"> Contact :  {{data.contact.first_name}} {{data.contact.last_name}}</h1>
                </span>
                <span>
                    <h1 class="mb-4 font-bold text-1xl"> Email :  {{data.contact.email}}</h1>
                </span>
                <span>
                    <h1 class="mb-4 font-bold text-1xl"> Phone :  {{data.contact.phone}}</h1>
                </span>
                <span>
                    <h1 class="mb-4 font-bold text-1xl"> Label Name :  {{data.label.label_name}}</h1>
                </span>
                <span>
                    <h1 class="mb-4 font-bold text-1xl"> Quantity :  {{getBoxes(data.quantity)}} -- ({{data.quantity}})</h1>
                </span>
                <span>
                    <h1 class="mb-4 font-bold text-1xl"> Order Total Cost : {{data.total_cost}} €</h1>
                </span>
                 <span>
                    <h1 class="mb-4 font-bold text-1xl"> Order Date :  {{data.created_at}}</h1>
                </span>
                <span>
                      <h1 class="mb-4 font-bold text-1xl"> Delivery Date :  {{data.delivery_date}}</h1>
                </span>

                <span>
                    <h1 class="mb-4 font-bold text-2xl"> Delivery Address : </h1>
                    <span style="font-size: 19px;">
                        {{data.contact.address}}, {{data.contact.city}}, 
                        {{data.contact.region}}, {{data.contact.country}}, {{data.contact.postal_code}}
                    </span>
                </span>
            </span>
        </div>

        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center" v-if="$page.props.auth.user.owner">
          <button v-if="!order.deleted_at && $page.props.auth.user.owner && false" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Order</button>
          <!-- <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update User</loading-button> -->
        </div>
     
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Pdf from 'vue-pdf'

export default {
  metaInfo() {
    return {
      title: `${this.data.id}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    Pdf,
  },
  layout: Layout,
  props: {
    order: Array,
  },
  remember: 'form',
  data() {
    return {
        data: this.order[0]
    }
  },
  mounted(){
    //   console.log(this.data);
  },
  methods: {
    destroy() {
      if (confirm('Are you sure you want to delete this User?')) {
        this.$inertia.delete(this.route('orders.destroy', this.data.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this User?')) {
        this.$inertia.put(this.route('orders.restore', this.data.id))
      }
    },
    getBoxes(quantity){
      switch(quantity){
        case 1000:
          return '1 Box'
        break;
        case 2000:
          return '2 Boxes'
        break;
        case 3000:
          return '3 Boxes'
        break;
        case 4000:
          return '4 Boxes'
        break;
        default:
          return '5 Boxes'
      }
    }
  },
}
</script>
<style scoped>
 #order-detail{
    display:flex;
}
@media screen and (max-width: 720px) {
    #order-detail{
         display:block;
    }
}
</style>